import { Button } from "@/common/components/button";
import { AddressWrapper } from "./sub/style";
import { useState } from "react";
import { Modal } from "@/common/components/modal";
import AddressCard from "./sub/address-card";
import { dummyAddressData, newAddressForm } from "./sub/data";
import Form from "@/common/components/form/Form";

const Address = () => {
  const [showModal, setShowModal] = useState(false);
  // const [addNewAddressLoading, setAddNewAddressLoading] = useState(false);
  // const [editingAddress, setEditingAddress] = useState<string | null>(null);

  return (
    <AddressWrapper>
      <div className="button-wrapper">
        <Button onClick={() => setShowModal(true)}>Add New Address</Button>
      </div>
      <div className="addresses">
        {dummyAddressData.map((item, index) => (
          <div key={item.id} className="address-card">
            <AddressCard index={index + 1} address={item} />
          </div>
        ))}
      </div>
      <Modal
        isOpen={showModal}
        close={() => setShowModal(false)}
        title="Create New Address"
      >
        <div className="modal max-w-[900px] md:w-[700px]">
          <Form
            formInputs={newAddressForm}
            processInputs={(data) => console.log(data)}
          />
        </div>
      </Modal>
    </AddressWrapper>
  );
};

export default Address;
